'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

function initRating() {
    $('.product-review').each(function (index, review) {
        const $review = $(review);
        const pid = $review.data('pid');
        
        if (!pid) {
            return;
        }
        
        const ratingValue = getRating(pid);
        const baseRating = Math.floor(ratingValue);
        const $ratingContainer = $review.find('.rating');
        
        // Add full stars
        for (let i = 0; i < baseRating; i++) {
            $ratingContainer.append('<i class="fa fa-star"></i>');
        }
        
        // Add half star if applicable
        if (ratingValue > baseRating) {
            $ratingContainer.append('<i class="fa fa-star-half-o"></i>');
        }
        
        // Add empty stars to complete the 5-star rating
        const totalStars = baseRating + (ratingValue > baseRating ? 1 : 0);
        for (let i = totalStars; i < 5; i++) {
            $ratingContainer.append('<i class="fa fa-star-o"></i>');
        }
    });
}

export default {
    init: initRating
};
